module.exports = __webpack_public_path__ + "img/hr-car-2.96e08de3.png";